var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWizard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.159 4.224.792-1.579a.444.444 0 0 0-.597-.596l-1.58.79-1.58-.79a.444.444 0 0 0-.598.596l.792 1.579-.792 1.579a.444.444 0 0 0 .599.599l1.578-.792 1.58.792a.444.444 0 0 0 .598-.6l-.792-1.578zM9.868 2.132a.444.444 0 0 0-.513-.083l-1.579.79-1.578-.79a.444.444 0 0 0-.597.596l.79 1.579-.79 1.579a.444.444 0 0 0 .597.599l1.578-.792 1.579.792a.444.444 0 0 0 .599-.6l-.792-1.578.792-1.579a.444.444 0 0 0-.086-.513zm11.997 11.999a.444.444 0 0 0-.513-.084l-1.579.79-1.578-.79a.444.444 0 0 0-.599.597l.792 1.579-.792 1.579a.444.444 0 0 0 .599.598l1.578-.792 1.58.792a.444.444 0 0 0 .598-.598l-.792-1.58.792-1.578a.444.444 0 0 0-.086-.513zm-4.888-4.888L14.755 7.02a.444.444 0 0 0-.628 0L2.13 19.019a.444.444 0 0 0 0 .629l2.222 2.222a.444.444 0 0 0 .628 0L16.977 9.87a.444.444 0 0 0 0-.628zm-2.98 2.352L12.404 10l2.037-2.038 1.594 1.594-2.038 2.038z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizard);
export default __webpack_public_path__ + "static/media/wizard.9dc01e8c0315f837026a798df9d8e15c.svg";
export { ForwardRef as ReactComponent };